/**
 * The SPA half of the commercial-surface switch (#2077).
 *
 * `VITE_PUBLIC_REGISTRATION_ENABLED` is the build-time twin of the BFF's
 * `PUBLIC_REGISTRATION_ENABLED` (`apps/web/src/server/index.ts`). Strict `=== 'true'`: absent,
 * empty, 'TRUE', '1', 'yes' and every other value mean OFF. The default is the control, not the
 * configuration.
 *
 * It gates self-service signup (#2077) and, per Epic #1781's standing requirement, every new
 * commercial surface, including US #1806's organisation-management changes (#2568).
 *
 * A function rather than a constant, so it is read where it is used: a component that calls it
 * sees the environment a test stubs, without the module being re-imported.
 */
export function isPublicRegistrationEnabled(): boolean {
  return import.meta.env.VITE_PUBLIC_REGISTRATION_ENABLED === 'true'
}
